"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageWithCertificationSchema = exports.LanguageCertificationSchema = exports.LanguageSchema = void 0;
const zod_1 = require("zod");
exports.LanguageSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    code: zod_1.z.string(),
    localized: zod_1.z.object({
        en: zod_1.z.string(),
        th: zod_1.z.string(),
    }).optional(),
});
exports.LanguageCertificationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    languageId: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
});
exports.LanguageWithCertificationSchema = exports.LanguageSchema.extend({ certifications: exports.LanguageCertificationSchema.array() });
